export const messages = {
  en: {
    uodoComplaints: {
      title: 'Pending Complaints',
      back: 'Back',
      refresh: 'Refresh',
      orderNumber: 'Order Number',
      complaintType: 'Complaint Type',
      house: 'House',
      complainant: 'Complainant',
      complaintPhone: 'Complaint Phone',
      complaintStatus: 'Complaint Status',
      createTime: 'Create Time',
      operation: 'Operation',
      process: 'Process',
      detail: 'Detail',
      fetchError: 'Failed to fetch complaints data'
    },
    doingComplaint: {
      title: 'Process Complaint',
      description: 'Description',
      required: 'Required, please fill in the reply content',
      maxLength: 'Reply content exceeds 500 characters',
      placeholder: 'Required, please fill in the reply content',
      cancel: 'Cancel',
      submit: 'Submit',
      success: 'Processed successfully',
      error: 'Failed to process complaint'
    }
  },
  zh: {
    uodoComplaints: {
      title: '待办投诉单',
      back: '返回',
      refresh: '刷新',
      orderNumber: '订单编号',
      complaintType: '投诉类型',
      house: '房屋',
      complainant: '投诉人',
      complaintPhone: '投诉电话',
      complaintStatus: '投诉状态',
      createTime: '创建时间',
      operation: '操作',
      process: '办理',
      detail: '详情',
      fetchError: '获取投诉数据失败'
    },
    doingComplaint: {
      title: '办理投诉',
      description: '说明',
      required: '必填，请填写回复内容',
      maxLength: '回复内容超过500个字',
      placeholder: '必填，请填写回复内容',
      cancel: '取消',
      submit: '提交',
      success: '办理成功',
error: '办理投诉失败'
    }
  },
  'zh-TW': {
    uodoComplaints: {
      title: '待辦投訴單',
      back: '返回',
      refresh: '刷新',
      orderNumber: '訂單編號',
      complaintType: '投訴類型',
      house: '房屋',
      complainant: '投訴人',
      complaintPhone: '投訴電話',
      complaintStatus: '投訴狀態',
      createTime: '創建時間',
      operation: '操作',
      process: '辦理',
      detail: '詳情',
      fetchError: '獲取投訴數據失敗'
    },
    doingComplaint: {
      title: '辦理投訴',
      description: '說明',
      required: '必填，請填寫回復內容',
      maxLength: '回復內容超過500個字',
      placeholder: '必填，請填寫回復內容',
      cancel: '取消',
      submit: '提交',
      success: '辦理成功',
      error: '辦理投訴失敗'
    }
  }
}